import { useState, useEffect } from 'react';
import { NETWORKS } from '../config/networkConfig';

export function useNetwork() {
  const [currentNetwork, setCurrentNetwork] = useState(null);

  useEffect(() => {
    checkNetwork();
    if (window.ethereum) {
      window.ethereum.on('chainChanged', handleChainChanged);
      return () => {
        window.ethereum.removeListener('chainChanged', handleChainChanged);
      };
    }
  }, []);

  const checkNetwork = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        setCurrentNetwork(parseInt(chainId, 16));
      } catch (error) {
        console.error('Error checking network:', error);
      }
    }
  };

  const handleChainChanged = (chainId) => {
    setCurrentNetwork(parseInt(chainId, 16));
  };

  const switchNetwork = async (networkId) => {
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${parseInt(networkId).toString(16)}` }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [NETWORKS[networkId]],
          });
        } catch (addError) {
          console.error('Error adding network:', addError);
        }
      } else {
        console.error('Error switching network:', switchError);
      }
    }
  };

  return { 
    currentNetwork, 
    networks: Object.values(NETWORKS), 
    switchNetwork 
  };
}